'use client';

import { usePathname } from 'next/navigation';
import Link from 'next/link';

const categories = [
  { label: 'Latest', slug: 'latest' },
  { label: 'Press Release', slug: 'press-release' },
  { label: 'Updates', slug: 'updates' },
  { label: 'Industry', slug: 'industry' },
  { label: 'Awards', slug: 'awards' },
];

export function CategoryTabs() {
  const pathname = usePathname();

  // Extract current category from pathname
  const getCurrentCategory = () => {
    if (pathname && pathname.startsWith('/press/topic/')) {
      const segments = pathname.split('/');
      return segments[3] || 'latest'; // /press/topic/[category] or /press/topic/[category]/page/[number]
    }
    // If we're on the main press page (/press) or paginated press (/press/page/[number]), show latest as active
    if (
      pathname === '/press' ||
      (pathname && pathname.startsWith('/press/page/'))
    ) {
      return 'latest';
    }
    return 'latest'; // Default fallback
  };

  const currentCategory = getCurrentCategory();

  return (
    <section className="bg-white">
      <div className="body-container mx-auto py-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          {/* Navigation tabs */}
          <nav className="flex space-x-8">
            {categories.map((category) => {
              const isActive = currentCategory === category.slug;
              const href =
                category.slug === 'latest'
                  ? '/press'
                  : `/press/topic/${category.slug}`;
              return (
                <Link
                  key={category.slug}
                  href={href}
                  scroll={false}
                  className={`pb-2 text-sm font-medium transition-colors cursor-pointer no-underline ${
                    isActive
                      ? 'text-primary-main border-b-2 border-primary-main'
                      : 'text-gray-600 hover:text-primary-main'
                  }`}
                >
                  {category.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </section>
  );
}
